import { TReduxActions } from '../../types/redux/actions';
import { ILegalCheckInfo } from '../../types/legalCheckInfo';
import { ELegalCheckInfoActions } from '../../constants/actionTypes/legalCheckInfo';
import { IStep } from '../../repositories/legal-check/entities/step/Step';

export const defaultState: ILegalCheckInfo = {
  demoReportLink: '',
  firstStep: {} as IStep,
  priceText: '',
  faq: [],
};

export function legalCheckInfoReducer(state: ILegalCheckInfo = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ELegalCheckInfoActions.setLegalCheckInfo:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
}
